import FilterReportDateItens from "../../../../components/filter/reportDateItens/filter";
import reqVenda from "../../../../services/reqMultiTenant/reqVenda";
import { gerarPdfVendasCompacto } from "../../../../util/reports/report-sales-compact";
import Notification from "../../../../components/toast";
import MainReportMatrix from "../../matrix";

const ReportListagemVendas = () => {
	const options = {
		title: "Vendas",
		subTitle: "Listagem das vendas realizadas no período - Relatório detalhado limitado à página atual",
		ident: "listagemVendas",
		identFilter: "filterListagemVendas",
		identReport: "reportListagemVendas",
		customActionLabel: "Imprimir Vendas Pag. {page}",
		tableColumns: [
			{ key: "id_venda", label: "Cod. Venda", align: "center", width: "100px" },
			{ key: "nome", label: "Cliente", align: "center" },
			{ key: "datavenda", label: "Dt. Venda", align: "center", format: "dateTime" },
			{ key: "valor", label: "Valor", align: "center", format: "currency" },
			{ key: "desconto", label: "Desconto", align: "center", format: "currency" },
			{ key: "acrescimo", label: "Acréscimo", align: "center", format: "currency" },
		],
		reportColumns: [
			{ key: "id_venda", label: "Cod. Venda", align: "center", visible: true },
			{ key: "nome", label: "Cliente", align: "center", visible: true },
			{ key: "datavenda", label: "Dt. Venda", align: "center", format: "date", visible: true },
			{ key: "valor", label: "Valor", align: "center", format: "currency", visible: true },
			{ key: "desconto", label: "Desconto", align: "center", format: "currency", visible: false },
			{ key: "acrescimo", label: "Acréscimo", align: "center", format: "currency", visible: false },
		],
		showTime: true,
		hasActive: true,
		activeLabel: { true: "Com parcela pendente", false: "Com parcela paga" },
		hasSaleType: false,
		hasParam: true,
		parametersDate: [{ id: 1, label: "Dt. Venda", value: "dtVenda" }],
		parametersFilter: [
			{ id: 1, label: "Cliente", value: "cliente" },
			{ id: 2, label: "Código da venda", value: "codVenda" },
		],
	};

	const fetch = async (filterData, newPage, perPage = 15) => {
		const newFilterData = { ...filterData, page: newPage, perPage };
		return reqVenda.listPaginate(newFilterData);
	};

	const handlePrintAllSales = async (vendas, paginaAtual, filtrosAplicados) => {
		if (!vendas || vendas.length === 0) {
			Notification.showToast({ message: "Nenhuma venda listada para imprimir.", type: "warning" });
			return;
		}

		try {
			// Captura os IDs das vendas exibidas na página atual
			const ids = vendas.map((item) => item.id_venda).filter(Boolean);

			Notification.showToast({
				message: `Buscando detalhamento de ${ids.length} vendas no servidor...`,
				type: "info",
			});

			// Faz a chamada real ao endpoint único passando a lista de IDs
			const response = await reqVenda.listLoteDetalhado(ids);
			const dadosVendasCompletas = response.data || [];

			if (dadosVendasCompletas.length === 0) {
				Notification.showToast({ message: "Nenhum detalhe de venda retornado do servidor.", type: "warning" });
				return;
			}

			// Gera o PDF consolidado com os dados reais agrupados vindos do servidor no modelo compacto
			gerarPdfVendasCompacto(dadosVendasCompletas, paginaAtual, filtrosAplicados);
		} catch (error) {
			console.error("Erro na impressão detalhada em lote:", error);
			Notification.showToast({ message: "Erro ao buscar dados das vendas no servidor.", type: "error" });
		}
	};

	return (
		<div className="flex flex-col mt-14 min-h-[calc(100vh-6.5rem)]">
			<MainReportMatrix
				options={options}
				fetch={fetch}
				FormFilter={FilterReportDateItens}
				onCustomAction={handlePrintAllSales}
			/>
		</div>
	);
};

export default ReportListagemVendas;
